import { setAlert } from "../alert";
import { SET_AUTOMOBILE_DATA } from "../../types";
import html from "../../../helpers/DOM";
import { handleError } from "../error";
import Axios from "axios";
import { handleResponse } from "../response";
import { toArray } from "../../../helpers";

/**
 * @name    updateStatus
 * @param   {Event} event
 */
export const updateStatus = event => async(dispatch, getState) => {
    try {
    //  DESC: get autombileData from redux state and make a copy of it as `newAutomobile`
        const { automobiles: { automobileData } } = getState();
        const newAutomobile = { ...automobileData };
        const { under_warranty } = newAutomobile;
        //  DESC: switch and case to up unique logic for fields that need to update more than just its value
        switch (event.target.name) {
            case "valuation_logs": {
            //  DESC: parse value string to JSON object as `newValuation`. In this case `newValuation` data type is Array type.
            //  DESC: `newValuationIndex` uses `newValuation` length and minus by 1 to get the lastes item in the array.
            //  DESC: We destructure Valuation Report Date and Value then assgin to valuation_date and value.
                const newValuation = JSON.parse(event.target.value);
                const newValuationIndex = newValuation.length - 1;
                const {
                    ["Valuation Report Date"]: valuation_date,
                    ["Value"]: value
                } = newValuation[newValuationIndex];

                //  DESC: update newAutomobileData with new value and valuation_date
                newAutomobile.current_valuation = value;
                newAutomobile.current_valuation_date = valuation_date;
                break;
            }
            case "warranty_description":
                if (!under_warranty || String(under_warranty) === "0") {
                    throw new Error(
                        "Vehicle is not under warranty. Field is not editable!"
                    );
                }
                break;

            default:
                break;
        }

        //  DESC: dispatch SET AUTOMOBILE DATA to update global automobileData object
        await dispatch({
            type: SET_AUTOMOBILE_DATA,
            payload: {
                ...newAutomobile,
                [event.target.name]: event.target.value
            }
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
    finally {
        dispatch(fieldToggle(event.target));
    }
};

export const fieldToggle = field => async(dispatch, getState) => {
    try {
        const { automobiles: { automobileData } } = getState();
        const newAutomobile = { ...automobileData };
        switch (field.name) {
            case "under_warranty":
                if (String(field.value) === "1") {
                    html.input("warranty_description").disabled = false;
                }
                else {
                    html.input("warranty_description").disabled = true;
                    await dispatch({
                        type: SET_AUTOMOBILE_DATA,
                        payload: {
                            ...newAutomobile,
                            warranty_description: ""
                        }
                    });
                }
            default:
                break;
        }
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

export const getValuationReport = () => async(dispatch, getState) => {
    try {
        const {
            MISC: { APP: { ROUTE } },
            automobiles: { automobileData }
        } = getState();
        const url = "/automobiles/valuation/" + ROUTE.id;
        const response = await Axios.get(url);
        dispatch(handleResponse(response));

        const newAutomobile = { ...automobileData };

        const newValuation = response.data.valuation_log;

        newAutomobile.current_valuation = newValuation.Value;
        newAutomobile.current_valuation_date =
            newValuation["Valuation Report Date"];
        let valuation_logs = toArray(newAutomobile.valuation_logs);

        if (valuation_logs) {
            valuation_logs.push(newValuation);
        }
        else {
            valuation_logs = [newValuation];
        }

        newAutomobile.valuation_logs = JSON.stringify(valuation_logs);

        await dispatch({
            type: SET_AUTOMOBILE_DATA,
            payload: newAutomobile
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};